var _style, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _g, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#21A365;}\r\n\t.st1{fill:#107C41;}\r\n\t.st2{fill:#185B37;}\r\n\t.st3{fill:#33C481;}\r\n\t.st4{fill:#17864C;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#036C70;}\r\n\t.st7{fill:#1A9BA1;}\r\n\t.st8{fill:#37C6D0;}\r\n\t.st9{fill:#04878B;}\r\n\t.st10{fill:#4F59CA;}\r\n\t.st11{fill:#7B82EA;}\r\n\t.st12{fill:#4C53BB;}\r\n\t.st13{fill:#0F78D5;}\r\n\t.st14{fill:#29A7EB;}\r\n\t.st15{fill:#0358A8;}\r\n\t.st16{fill:#0F79D6;}\r\n\t.st17{fill:#038387;}\r\n\t.st18{fill:#048A8E;}\r\n\t.st19{fill:#C8421D;}\r\n\t.st20{fill:#FF8F6A;}\r\n\t.st21{fill:#ED6B47;}\r\n\t.st22{fill:#891323;}\r\n\t.st23{fill:#AF2131;}\r\n\t.st24{fill:#C94E60;}\r\n\t.st25{fill:#E08195;}\r\n\t.st26{fill:#B42839;}\r\n\t.st27{fill:#0464B8;}\r\n\t.st28{fill:#0377D4;}\r\n\t.st29{fill:#4FD8FF;}\r\n\t.st30{fill:#1681D7;}\r\n\t.st31{fill:#0178D4;}\r\n\t.st32{fill:#042071;}\r\n\t.st33{fill:#168FDE;}\r\n\t.st34{fill:#CA64EA;}\r\n\t.st35{fill:#7E1FAF;}\r\n\t.st36{fill:#AE4BD5;}\r\n\t.st37{fill:#9332BF;}\r\n\t.st38{fill:#7719AA;}\r\n\t.st39{fill:#0078D4;}\r\n\t.st40{fill:#1490DF;}\r\n\t.st41{fill:#0364B8;}\r\n\t.st42{fill:#28A8EA;}\r\n\t.st43{fill:#41A5ED;}\r\n\t.st44{fill:#2C7BD5;}\r\n\t.st45{fill:#195ABE;}\r\n\t.st46{fill:#103E91;}\r\n\t.st47{fill:#2166C3;}\r\n\t.st48{opacity:0.2;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 29.8,
    width: 49.3,
    x: 78.7,
    y: 34.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 29.8,
    width: 49.3,
    x: 78.7,
    y: 64
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 29.8,
    width: 49.2,
    x: 29.5,
    y: 34.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.7,93.8V64H29.6v29.8v4.3v19.6c0,3.2,2.6,5.8,5.8,5.8h86.7c3.2,0,5.8-2.6,5.8-5.8V93.8H78.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.1,4.5H78.6v29.8h49.4V10.3C127.9,7.1,125.3,4.5,122.1,4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.7,4.5H35.5c-3.2,0-5.8,2.6-5.8,5.8v23.9h49.1V4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.5,96.5h-53c-3.5,0-6.4-2.9-6.4-6.4V37.9c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,93.6,63.1,96.5,59.5,96.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.5,82.4l-3.9-7.1c-1.6-2.8-2.6-4.7-3.7-6.8h-0.1c-0.9,2.1-1.8,4-3.3,6.8L26,82.4h-7.6l10.8-18.1L18.7,46.5   h7.7l3.9,7.4c1.2,2.2,2.1,4,3,6h0.2c1-2.2,1.7-3.8,2.9-6l3.9-7.4h7.6L37.2,64l11.1,18.4H40.5z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M66.7,37.3c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H30.4v5.7h35.2c3.5,0,6.4-2.9,6.4-6.4V43.6  C72.1,40.4,69.7,37.7,66.7,37.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.a428266ac05829ceeb106856f12d9b26.svg";
export { ForwardRef as ReactComponent };